import React from 'react';
import { useNavigate } from 'react-router-dom';
import {Button} from 'antd';

const PublicTopbar = () => {
    const navigate = useNavigate();

    const handleNavigateHome = () => {
        // Переход на главную страницу
        navigate('/');
    };

    const handleLogin = () => {
        // Переходим на страницу логина
        navigate('/login');
    };



    const handleSignIn = () => {
        // Переходим на страницу логина
        navigate('/registration');
    };





    // Стили как объекты JS (inline-styles)
    const topbarStyle = {
        width: '100%',
        height: '40px',
        backgroundColor: '#f7f7f8',
        position: 'sticky',
        top: 0,
        zIndex: 999,
      //  borderBottom: '2px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const topbarWrapperStyle = {
        width: '100%',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        transition: 'margin-left 0.3s ease',
    };

    const logoSectionStyle = {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    };

    const logoTextStyle = {
        fontWeight: 'bold',
        fontSize: '18px',
        color: '#027b83',
    };

    return (
        <div style={topbarStyle}>
            <div style={topbarWrapperStyle}>
                <button
                    type="button"
                    aria-label="RETRIEVE"
                    style={{ ...logoSectionStyle, background: 'none', border: 'none', padding: 0 }}
                    onClick={handleNavigateHome}
                >
                    <span style={logoTextStyle}>RETRIEVE</span>
                </button>
                <div>


                    <div>

                        <Button type="default" onClick={handleSignIn} size="small" style={{marginRight: '10px'}}>
                            Sign In
                        </Button>
                        <Button type="primary" onClick={handleLogin} size="small" >
                            Login
                        </Button>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default PublicTopbar;
